import { LoaderFunctionArgs, json } from "@netlify/remix-runtime";
import { MetaFunction, useLoaderData } from "@remix-run/react";
import { staticHeaders } from "~/lib/cache/static-headers";
import { Container } from "~/components/container";
import { CalendarTypeSwitcher } from "~/components/calendar/calendar-type-switcher";

import { env } from "~/lib/env";
import { FranklinParkCalendar } from "~/lib/calendar/calendar";
import { ErrorBoundaryy } from "~/templates/error-boundary";

export const meta: MetaFunction = () => {
  return [
    {
      title: "Open Gym Calendar",
    },
    {
      name: "description",
      content: "Discover open gym times at the Park District of Franklin Park.",
    },
  ];
};

export const loader = async ({ request, context, params }: LoaderFunctionArgs) => {
  const headers = await staticHeaders(request);

  const apiUrl = env("BACKEND_API_URL");
  const url = new URL(request.url);
  const month = url.searchParams.get("month");
  const year = url.searchParams.get("year");

  const res = await fetch(`${apiUrl}/events/open-gym`);
  const events = await res.json();

  return json({ events, month, year }, { headers });
};

export default function Index() {
  const { events, month, year } = useLoaderData<typeof loader>();

  return (
    <main className="" data-searchable>
      <FranklinParkCalendar key={month + year} events={events} month={month} year={year} calendarType="open-gym" />
    </main>
  );
}

export const ErrorBoundary = ErrorBoundaryy;
